import React from "react";
import { AddIcon } from "../Icons/Icons";
export const CreateButton = ({ label, ...props }) => {
    return (
        <button {...props} className="btn-primary align_center"><AddIcon />&nbsp;{label}</button>
    )
}